import axios from 'axios'
import {store} from '../store'
import router from '../router'

export const Http = axios.create({
  baseURL: 'api/'
})

Http.interceptors.request.use(function (request) {
  request.headers.Authorization = 'Bearer ' + store.state.authStore.token.auth_token

  return request
})

Http.interceptors.response.use(response => {
  if (response !== undefined) {
    return response
  } else {
    return {length: 0}
  }
}, error => {
  if (error.response !== undefined) {
    if (error.response.status === 401) { // need login
      const config = error.config
      return store.dispatch('authStore/login', { pin: store.state.authStore.token.pin }, { root: true }).then(() => {
        let url = config.url.replace('api', '')
        config.url = url
        config.headers['Authorization'] = `Bearer ${store.state.authStore.token.auth_token}`

        return new Promise((resolve, reject) => {
          axios.request(config).then(resp => {
            resolve(resp)
          }).catch((err) => {
            reject(err)
          })
        })
      }).catch(() => {
        router.push({ name: 'LoginView' })
      })
    } else if (error.response.status === 403) { // no access

    }
  }

  return Promise.reject(error)
})

export const AuthHttp = axios.create({})

export const OuterHttp = axios.create({
  headers: { 'Access-Control-Allow-Origin': '*' }
})

OuterHttp.interceptors.request.use(function (outerRequest) {
  outerRequest.headers.Authorization = 'Bearer ' + store.state.authStore.token.auth_token

  return outerRequest
})



// WEBPACK FOOTER //
// ./src/helpers/http-helper.js